import { createBrowserHistory } from 'history';
import config from 'config';

const basename = `${config.UI_SUFFIX}/`;
const history = createBrowserHistory({ basename });

export default history;
